import React from 'react';
import { Navigate } from 'react-router-dom';

/** layouts */
import { BlankLayout, NotFound, Forbidden, Unauthorized } from '@europrocurement/flexy-components';

import { KeycloakRoute, REALM_DEBUG } from '@europrocurement/l2d-keycloak';
/** end layouts */

/** pages */

import {
    Debug,
    OfferRouter,
    ParcoursFormaliteRouterBack,
    SocietesRouterBack,
} from '@europrocurement/l2d-modules';
import { B2DSymboleIcon } from '@europrocurement/l2d-icons';
import { Tooltip } from '@mui/material';
import { DocumentTypeRouter } from '@europrocurement/l2d-modules/src/modules/DocumentTypes';
import { FormalityRouter } from '../pages/Formalities';
import { PublisherRouter } from '../pages/Fournisseurs';
import { UtilisateursRouter } from '../pages/Utilisateurs';

import { FacturesRouterBack } from '../pages/Factures';
import { SignatureRouter } from '../pages/Signature';
import { DossierRouter } from '../pages/Dossiers';
import { OrderRouter } from '../pages/Orders';
import { PrescripteurRouter } from '../pages/Prescripteurs';
import { CRMRouter } from '../pages/CRM';
/** end pages */

/** menu */
import menuEntries from './menuEntries';
/** end menu */

import { AchatsRouter } from '../pages/Achats';
import B2DLayout from './B2DLayout';

import { version } from '../../package.json';
import { TachesRouter } from '../pages/Taches';
import Dashboard from '../pages/Dashboard/Dashboard';
import { RouteErrorBoundary } from './RouteErrorBoundary';

const Router = [
    {
        path: '/',
        element: (
            <B2DLayout
                menuEntries={menuEntries}
                footerProps={{
                    children: (
                        <Tooltip title={`Version ${version}`}>
                            {'   '}
                            <B2DSymboleIcon style={{ maxHeight: '24px' }} />
                            {'   '}
                        </Tooltip>
                    ),
                }}
            />
        ),
        errorElement: <RouteErrorBoundary />,
        children: [
            { path: '/', element: <Navigate to="/accueil" /> },
            {
                path: 'accueil',
                exact: true,
                element: <Dashboard />,
                handle: { title: 'Accueil' },
            },
            {
                path: 'debug',
                element: (
                    <KeycloakRoute roles={REALM_DEBUG}>
                        <Debug panelEnvironnement={{ version }} />
                    </KeycloakRoute>
                ),
                handle: { title: 'Debug' },
            },
            PrescripteurRouter,
            CRMRouter,
            FormalityRouter,
            DocumentTypeRouter,
            PublisherRouter,
            AchatsRouter,
            ...OfferRouter,
            SignatureRouter,
            UtilisateursRouter,
            ParcoursFormaliteRouterBack,
            DossierRouter,
            OrderRouter,
            SocietesRouterBack,
            FacturesRouterBack,
            TachesRouter,
        ],
    },
    {
        path: '/errors',
        element: <BlankLayout />,
        children: [
            {
                path: '404',
                element: <NotFound />,
                handle: { title: 'Erreur - Page introuvable' },
            },
            {
                path: '403',
                element: <Forbidden />,
                handle: { title: 'Erreur - Accès non autorisé' },
            },
            {
                path: '401',
                element: <Unauthorized />,
                handle: { title: 'Erreur - Authentification nécessaire' },
            },
        ],
        handle: { title: 'Erreur inconnue' },
    },
    {
        path: '*',
        element: <NotFound />,
        handle: { title: 'Erreur - Page introuvable' },
    },
];

export default Router;
